/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    ORGANISATION_DOMAIN: 'domain',
    USER_EMAIL: 'email',
    ORGANISATION_EMAIL: 'email',
    PROMO_CODE: 'promoCode',
    VOUCHER: 'voucher',
};
